import React from "react";
import { t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

import { FinancingModalTrigger } from "./Trigger";

import styles from "./Minicart.module.scss";

interface Props {
    closeModal: () => void;
}

export const FinancingModalTriggerBannerMinicart = (
    props: Props,
): React.JSX.Element => {
    return (
        <div className={styles.root}>
            <div className={styles.cardImageHolder} aria-hidden="true"></div>
            {richT(
                t`<Trigger>Check if you Pre-Qualify</Trigger> <P>without
                    affecting your credit score</P>`,
                {
                    Trigger: (children) => (
                        <FinancingModalTrigger
                            modalType="prequal-app"
                            onClick={props.closeModal}
                        >
                            {children}
                        </FinancingModalTrigger>
                    ),
                    P: (children) => <p>{children}</p>,
                },
            )}
        </div>
    );
};
